import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import EntityMessagePrompt from 'servicestack/messaging/entity-message-prompt'


function EntityMessagePromptDirective($window, $parse, $session) {
    // Introduce custom elements for IE8
    $window.document.createElement('entity-message-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onEntityMessageSaved = attr.onEntityMessageCreated || attr.onEntityMessageSaved;

            var $targets = (attr.entityMessagePromptClickSelector ? element.find(attr.entityMessagePromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.entityMessagePrompt || attr.ngModel || attr.entity || attr.message) || {
                    entityId: attr.entityId,
                    entityType: attr.entityType,
                    message: attr.message
                };
                if (!model.message) {
                    model.message = {
                        messageText: '',
                        createdBy: $session.userName,
                        createdOn: new Date()
                    }
                }
                if (model.entityId && model.entityType) {
                    model.message.tags = {
                        EntityId: model.entityId,
                        EntityType: model.entityType
                    };
                }
                EntityMessagePrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onEntityMessageSaved) {
                            $parse(attr.onEntityMessageSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default EntityMessagePromptDirective;